import React from 'react';
import { useSiteContent } from '../../context/SiteContentContext';
import { Quote } from 'lucide-react';
import { motion } from 'framer-motion';

const Testimonials = () => {
  const { siteContent } = useSiteContent();
  const testimonials = siteContent?.testimonials || {};

  if (testimonials.visible === false) return null;

  const items = testimonials.items || [];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="text-center mb-14 md:mb-16"
        >
          <span className="text-xs font-medium text-slate-400 uppercase tracking-[0.2em] mb-4 block">
            {testimonials.label || 'Testimonials'}
          </span>
          <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-slate-900">
            {testimonials.title || 'What Parents Say'}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {items.map((item, index) => {
            const itemKey = item.author?.en || item.author || `testimonial-${index}`;
            return (
              <motion.div
                key={itemKey}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.5, delay: index * 0.1, ease: [0.22, 1, 0.36, 1] }}
                className="bg-slate-50/70 rounded-xl p-6 sm:p-7 border border-slate-100"
              >
                <Quote className="w-7 h-7 text-slate-200 mb-4" strokeWidth={1.5} />
                <p className="text-slate-600 leading-relaxed mb-5 text-sm">&ldquo;{item.text}&rdquo;</p>
                <p className="text-xs font-medium text-slate-400">— {item.author}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
